const AutomationIcon = () => {
  return (
    <>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M27.3345 20.1848V11.7266C27.8572 11.5376 28.3505 11.2462 28.7692 10.8284L30.8546 8.74747C32.3813 7.224 32.3813 4.74521 30.8546 3.22307L28.7692 1.1421C27.2425 -0.380036 24.761 -0.381366 23.233 1.1421L21.1489 3.2244C20.7302 3.64219 20.4382 4.13449 20.2488 4.65606H11.8192C11.1831 2.02824 8.82437 0.0656955 6.00025 0.0656955C2.69211 0.0656955 0 2.75073 0 6.05313C0 8.65167 1.6774 10.8457 4.00017 11.6733V21.3557H3.73349C1.67474 21.3557 0 23.0268 0 25.0812V28.2732C0 30.3275 1.67474 32 3.73349 32H6.93362C8.99237 32 10.6671 30.3275 10.6671 28.2732V25.0812C10.6671 23.0268 8.99237 21.3557 6.93362 21.3557H6.66694V11.974C9.23638 11.6853 11.3231 9.7986 11.8605 7.31581H20.2475C20.4369 7.83738 20.7289 8.32968 21.1475 8.74747L23.2316 10.8284C23.6503 11.2449 24.1437 11.5376 24.6664 11.7252V20.1848C21.9996 20.7929 19.9995 23.1679 19.9995 26.0112C19.9995 29.3123 22.6916 31.9987 25.9997 31.9987C29.3079 31.9987 32 29.3123 32 26.0112C32 23.1679 30.0012 20.7929 27.3345 20.1848Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default AutomationIcon;
